var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../../application/stores/auth.store';
import Loader from '../../../components/common/Loaders/Loader';
const LoginSage = () => {
    const [searchParams] = useSearchParams();
    const { loginFromSage } = useAuthStore();
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        const encryptedId = searchParams.get('id');
        if (encryptedId) {
            (() => __awaiter(void 0, void 0, void 0, function* () {
                yield loginFromSage(encryptedId);
                // Construir la nueva ruta quitando '/sage'
                const pathWithoutSage = location.pathname.replace(/^\/sage/, '') || '/';
                // Filtrar la query string para eliminar 'id'
                const newSearchParams = new URLSearchParams(searchParams);
                newSearchParams.delete('id');
                const newSearch = newSearchParams.toString();
                const redirectTo = pathWithoutSage + (newSearch ? `?${newSearch}` : '');
                navigate(redirectTo, { replace: true });
            }))();
        }
    }, [loginFromSage, searchParams, location, navigate]);
    return _jsx(Loader, { fullBlack: true });
};
export default LoginSage;
